import React from "react";

const WriterApplicationForm = React.lazy(() => import("app/(become-writer)"));
const TopicDetails = React.lazy(() => import("app/(explore-topics)"));
const PageHomeDemo6 = React.lazy(() => import("app/(home)/page"));
const ManageInterests = React.lazy(() => import("app/(manage-interests)"));
const MyAccount = React.lazy(() => import("app/(my-acccount)"));
const DashboardBilingAddress = React.lazy(
  () => import("app/(others)/dashboard/billing-address/page")
);
const DashboardEditProfile = React.lazy(
  () => import("app/(others)/dashboard/edit-profile/page")
);
const DashboardPosts = React.lazy(
  () => import("app/(others)/dashboard/posts/page")
);
const DashboardSubmitPost = React.lazy(
  () => import("app/(others)/dashboard/submit-post/page")
);
const DashboardSubcription = React.lazy(
  () => import("app/(others)/dashboard/subscription/page")
);
const PageLogin = React.lazy(() => import("app/(others)/login/page"));
const PageSignUp = React.lazy(() => import("app/(others)/signup/page"));
const PageSingle = React.lazy(
  () => import("app/(singles)/(default)/single/page")
);
const Stats = React.lazy(() => import("app/(stats)"));
// const Leaderboard = React.lazy(() => import("app/(stats)/leaderboard"));
const Write = React.lazy(() => import("app/(write)"));
const Followers = React.lazy(() => import("app/author/followers"));
const Followings = React.lazy(() => import("app/author/followings"));
const PageAuthor = React.lazy(() => import("app/author/page"));
const Stories = React.lazy(() => import("app/(stories)"));

export {
  DashboardBilingAddress,
  DashboardEditProfile,
  DashboardPosts,
  DashboardSubcription,
  DashboardSubmitPost,
  Followers,
  Followings,
  ManageInterests,
  MyAccount,
  PageAuthor,
  PageHomeDemo6,
  PageLogin,
  PageSignUp,
  PageSingle,
  Stats,
  Stories,
  TopicDetails,
  // Leaderboard,
  Write,
  WriterApplicationForm,
};
